import React from 'react';
import { ButtonText } from '../headings/ButtonText';
import { Caption } from '../headings/Caption';
import styles from './InputField.module.css';

type InputElement = HTMLInputElement;

// For inputs inside a <form> where Enter must not submit it.
const preventEnter = (next?: (e: React.KeyboardEvent<InputElement>) => void) => (e: React.KeyboardEvent<InputElement>) => {
  if (e.key === 'Enter') e.preventDefault();
  next?.(e);
};

export const Input = React.forwardRef<InputElement, any>(
  (
    {
      className,
      showTitle,
      title,
      showOptTxt,
      optionalText,
      showDescription,
      description,
      ignoreEnter,
      onKeyDown,
      ...rest
    }: any,
    ref
  ) => {
    return (
      <>
        <div className="d-flex flex-row">
          {showTitle && title && <ButtonText text={title} />}
          {showOptTxt && optionalText && (
            <div className="ps-1 align-self-center">
              <Caption text={optionalText} />
            </div>
          )}
        </div>
        <input
          ref={ref}
          className={[styles.custom_input_style, 'form-control', className].filter(Boolean).join(' ')}
          onKeyDown={ignoreEnter ? preventEnter(onKeyDown) : onKeyDown}
          {...rest}
        />
        {showDescription && description && (
          <div className="pt-2">
            <Caption text={description} />
          </div>
        )}
      </>
    );
  }
);

Input.displayName = 'Input';
